import React, { useState, useCallback } from 'react'
import { Icon } from 'semantic-ui-react'
import CostTypeForm from '@EUForms/CostTypeForm'
import { useSelector } from 'react-redux'
import List from '@commonComponents/List'
import { FormTitle } from '@commonComponents/FormTitle'

const LineItemCharges = ({ invoiceId, merchandiseId, enableFields={} }) => {
  const dataSource = useSelector((state) => {
    return state.ValueBuildUpReducer.shipmentInvoice
      .find((c) => c.invoiceId === invoiceId)
      ?.merchandise?.find((a) => a.merchandiseId === merchandiseId)?.merchandiseCostType
  }) || []
  const renderItem = useCallback(
    (item) => <CostTypeForm dataSource={item} key={item.costTypeId} enableFields={enableFields} />,
    [dataSource]
  )
  return (
    <>
      <FormTitle
        title='ADDITIONS & DEDUCTIONS'
        boxNumber={'4/9'}
        containerStyle={{ width: '100%', marginTop: '12px' }}
      />
      <List
        className='responsiveGridCss'
        containerStyle={{ width: '100%' }}
        dataSource={dataSource}
        renderItem={renderItem}
      />
    </>
  )
}

export default React.memo(LineItemCharges)
